import { render, staticRenderFns } from "./ForgotUsername.vue?vue&type=template&id=5bf3a445"
import script from "./ForgotUsername.vue?vue&type=script&lang=ts"
export * from "./ForgotUsername.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports